import { ClerkProvider as ClerkProvider$1 } from '@clerk/clerk-react';
export * from '@clerk/clerk-react';
import { useRouteContext, ScriptOnce } from '@tanstack/react-router';
import { useEffect } from 'react';
import { isClient } from '../utils/index.js';
import { ClerkOptionsProvider } from './OptionsContext.js';
import { useAwaitableNavigate } from './useAwaitableNavigate.js';
import { pickFromClerkInitState, mergeWithPublicEnvs } from './utils.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

// src/client/ClerkProvider.tsx
var SDK_METADATA = {
  name: "@clerk/tanstack-react-start",
  version: "0.18.2"
};
var awaitableNavigateRef = { current: void 0 };
function ClerkProvider({ children, ...providerProps }) {
  const awaitableNavigate = useAwaitableNavigate();
  const routerContext = useRouteContext({
    strict: false
  });
  useEffect(() => {
    awaitableNavigateRef.current = awaitableNavigate;
  }, [awaitableNavigate]);
  const clerkInitState = isClient() ? window.__clerk_init_state : routerContext?.clerkInitialState;
  const { clerkSsrState, ...restInitState } = pickFromClerkInitState(clerkInitState?.__internal_clerk_state);
  const mergedProps = {
    ...mergeWithPublicEnvs(restInitState),
    ...providerProps
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ScriptOnce, { children: `window.__clerk_init_state = ${JSON.stringify(routerContext?.clerkInitialState)};` }),
    /* @__PURE__ */ jsx(ClerkOptionsProvider, { options: mergedProps, children: /* @__PURE__ */ jsx(
      ClerkProvider$1,
      {
        initialState: clerkSsrState,
        sdkMetadata: SDK_METADATA,
        routerPush: (to) => awaitableNavigateRef.current?.({
          to,
          replace: false
        }),
        routerReplace: (to) => awaitableNavigateRef.current?.({
          to,
          replace: true
        }),
        ...mergedProps,
        children
      }
    ) })
  ] });
}
ClerkProvider.displayName = "ClerkProvider";

export { ClerkProvider };
//# sourceMappingURL=ClerkProvider.js.map
//# sourceMappingURL=ClerkProvider.js.map